<script setup>
import UserMenuList from 'components/UserMenuList.vue';
import { useBreakpoint } from 'composables/breakpoint';
import { QResizeObserver } from 'quasar';
import { ref } from 'vue';

const breakpoint = useBreakpoint();

const isDialogVisible = ref(false);
const isMenuVisible = ref(false);

function toggleUserMenuDialog() {
    isDialogVisible.value = !isDialogVisible.value;
}

function toggleMenuOrDialogBasedOnScreenWidth() {
    if (breakpoint.lt.md && isMenuVisible.value) {
        isMenuVisible.value = false;
        isDialogVisible.value = true;
    } else if (!breakpoint.lt.md && isDialogVisible.value) {
        isDialogVisible.value = false;
        isMenuVisible.value = true;
    }
}
</script>

<template>
    <div class="user-menu-toggle flex">
        <q-resize-observer @resize="toggleMenuOrDialogBasedOnScreenWidth"/>
        <template v-if="!breakpoint.lt.md">
            <q-btn text-color="primary" icon="sym_r_menu" padding="6px" aria-label="Toggle menu" flat>
                <q-menu v-model="isMenuVisible" anchor="bottom right" self="top right" auto-close>
                    <UserMenuList/>
                </q-menu>
            </q-btn>
        </template>
        <template v-else>
            <q-btn @click="toggleUserMenuDialog" text-color="primary" icon="sym_r_menu" padding="6px" aria-label="Toggle menu" flat/>
        </template>
        <q-dialog v-model="isDialogVisible" transition-show="fade" transition-hide="fade" class="user-menu-dialog" maximized>
            <q-card class="flex column full-height">
                <q-card-section class="row items-center justify-between">
                    <div class="text-h5">Menu</div>
                    <q-btn icon="sym_r_close" aria-label="Close menu" padding="6px" flat v-close-popup/>
                </q-card-section>
                <q-separator/>
                <q-card-section class="q-pa-none col scroll">
                    <UserMenuList/>
                </q-card-section>
            </q-card>
        </q-dialog>
    </div>
</template>

<style lang="scss" scoped>
.user-menu-toggle .q-btn {
    aspect-ratio: 1/1;

    .q-icon {
        margin-left: 1px;
    }
}
</style>
